import { render } from "./QuotationManagement.vue?vue&type=template&id=71d8ca98&scoped=true"
import script from "./QuotationManagement.vue?vue&type=script&lang=js"
export * from "./QuotationManagement.vue?vue&type=script&lang=js"

import "./QuotationManagement.vue?vue&type=style&index=0&id=71d8ca98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71d8ca98"]])

export default __exports__